<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import ScenarioPicker from '../../components/ScenarioPicker.vue'
import { loadScenarioOptions, preparationItems, scenarioId, selectScenario } from './scenario.js'

const route = useRoute()
const { locale, t } = useI18n()

onMounted(async () => {
  const requestedScenarioId = route.query.scenario_id
  if (requestedScenarioId !== undefined) {
    if (typeof requestedScenarioId !== 'string') {
      throw new Error(`Unknown intent video scenario: ${String(requestedScenarioId)}`)
    }
    selectScenario(requestedScenarioId)
  }
  await loadScenarioOptions(locale.value)
})
</script>

<template>
  <ScenarioPicker
    v-model="scenarioId"
    :items="preparationItems"
    :empty-label="t('visualGameAdmin.scenarioPicker.title')"
    :search-placeholder="t('visualGameAdmin.scenarioPicker.searchPlaceholder')"
    :empty-result="t('visualGameAdmin.scenarioPicker.emptyResult')"
  />
</template>
